import { UserRank } from '../../types';

export const getRankRingParams = (rank?: UserRank) => {
    switch (rank) {
        case 'union':
            return {
                ringClass: 'ring-offset-2 ring-offset-background ring-2 ring-blue-500 dark:ring-blue-400',
                gradientBorder: 'bg-linear-to-r from-blue-400 to-blue-600',
                label: 'Union'
            };
        case 'watcher':
            return {
                ringClass: '',
                gradientBorder: '',
                label: 'User'
            };
        case 'legion':
            return {
                ringClass: 'p-1 rounded-full bg-linear-to-tr from-emerald-950 via-emerald-400 to-emerald-950 shadow-[0_0_15px_rgba(52,211,153,0.3)]',
                gradientBorder: 'bg-linear-to-tr from-emerald-950 via-emerald-400 to-emerald-950',
                label: 'Legion'
            };
        default:
            return {
                ringClass: '',
                gradientBorder: '',
                label: ''
            };
    }
};

export const getRankBadge = (rank?: UserRank) => {
    switch (rank) {
        case 'union':
            return '🛡️';
        case 'watcher':
            return null;
        case 'legion':
            return null;
        default:
            return null;
    }
};

/**
 * Sanitizes location to prevent redundant "Egypt, Egypt" or "Cairo, Egypt" 
 * if only the country is desired or if they are identical.
 */
export const sanitizeLocation = (location?: string, country?: string) => {
    if (!location) return country || '';

    // If location contains a comma, likely "City, Country" -> return "Country"
    if (location.includes(',')) {
        const parts = location.split(',');
        return parts[parts.length - 1].trim();
    }

    // If location equals country (case-insensitive), return country
    if (country && location.toLowerCase() === country.toLowerCase()) {
        return country;
    }

    // Fallback: Return original location (e.g., "France")
    return location;
};
